import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "abidjan-freshkart",
  founder: "Aïssata Touré",
  company: "FreshKart",
  city: "Abidjan",
  country: "Côte d'Ivoire",
  pillar: "coaching",
  outcomeShort: {
    en: "Cut delivery time 42% with weekly ops coaching",
    fr: "−42 % sur le temps de livraison grâce au coaching ops hebdo",
  },
  title: {
    en: "How FreshKart cut its Abidjan delivery time by 42% in one quarter",
    fr: "Comment FreshKart a réduit son temps de livraison de 42 % à Abidjan en un trimestre",
  },
  subtitle: {
    en: "A weekly fractional ops coach helped FreshKart redesign its hub-and-spoke model for Plateau and Cocody.",
    fr: "Un coach ops fractionné hebdomadaire a aidé FreshKart à redessiner son modèle hub-and-spoke pour le Plateau et Cocody.",
  },
  body: {
    en: {
      context: "FreshKart was a 14-person fresh-produce delivery startup serving Abidjan with a single warehouse in Yopougon. Average delivery time was 87 minutes — too slow to defend against the incumbents.",
      challenge: "Aïssata had no ops co-founder and her ops manager had never run a multi-hub network. She needed senior expertise without paying a full-time salary she couldn't afford.",
      approach: "She booked a weekly 90-minute coaching slot with a former Glovo Africa ops director through Bootpreneurs Coaching. Together they redesigned the network into 3 micro-hubs, built a courier batching algorithm in spreadsheets, and rolled out a 4-week pilot.",
      outcome: "Average delivery time dropped from 87 to 51 minutes (−42%). Courier utilisation rose from 38% to 64%. The pilot paid for 12 months of coaching in week 6.",
      quote: "I didn't need a co-founder. I needed someone who'd already solved this exact problem, for 90 minutes a week.",
      quoteAuthor: "Aïssata Touré · Founder, FreshKart",
    },
    fr: {
      context: "FreshKart était une startup de livraison de produits frais de 14 personnes desservant Abidjan depuis un seul entrepôt à Yopougon. Temps de livraison moyen : 87 minutes — trop lent face aux acteurs en place.",
      challenge: "Aïssata n'avait pas de co-fondateur ops et son responsable ops n'avait jamais géré un réseau multi-hubs. Il lui fallait de l'expertise senior sans le salaire temps plein qu'elle ne pouvait pas se permettre.",
      approach: "Elle a réservé un créneau hebdomadaire de 90 minutes avec un ancien directeur ops de Glovo Africa via Bootpreneurs Coaching. Ensemble ils ont redessiné le réseau en 3 micro-hubs, construit un algorithme de batching coursier sur tableur, et lancé un pilote de 4 semaines.",
      outcome: "Temps de livraison moyen passé de 87 à 51 minutes (−42 %). Utilisation des coursiers de 38 % à 64 %. Le pilote a payé 12 mois de coaching dès la 6ᵉ semaine.",
      quote: "Je n'avais pas besoin d'un co-fondateur. J'avais besoin de quelqu'un qui avait déjà résolu ce problème exact, 90 minutes par semaine.",
      quoteAuthor: "Aïssata Touré · Fondatrice, FreshKart",
    },
  },
};
export default cs;
